import { AxiosInstance } from "axios"
import { Merchant } from "../supplier/reporting/merchants/merchantTypes"
import { DeviceReportBase } from "../merchant/merchant/home/merchantHomeTypes"
import { SupportDeviceSupplier } from "./reports/supportTypes"

export enum SupportReportQuery {
    DEVICE_REPORT = "deviceReport",
}

type FetchAllMerchantsParams = Readonly<{}>

export type MerchantsResponse = Readonly<{
    merchants: Merchant[]
}>

type FetchAllSuppliersParams = Readonly<{}>

export type SuppliersResponse = Readonly<{
    suppliers: Merchant[]
}>

export async function fetchAllMerchants(
    {}: FetchAllMerchantsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MerchantsResponse> {
    const response = await axios.get(`/merchants`, { signal })
    return response.data
}

export async function fetchAllSuppliers(
    {}: FetchAllSuppliersParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SuppliersResponse> {
    const response = await axios.get(`/suppliers`, { signal })
    return response.data
}

export type DeviceReportResponse = Readonly<{
    deviceReport?: DeviceReportBase
    suppliers: SupportDeviceSupplier[]
}>

export async function fetchDeviceReport({}, axios: AxiosInstance, signal?: AbortSignal): Promise<DeviceReportResponse> {
    const { data } = await axios.get("/devices/status", {
        params: {},
        signal,
    })

    return data
}
